import ajax from '../http/ajax'

export const getAddressList = () => {
    return ajax.get('getAddressList')
}
/**
 *
 * delivery_id: 收货地址
 * delivery_way: 配送方式， 0: 到店提货 1：邮寄到家
 * sstore_id: 门店id
 * goods: "[{ // JSON字符串格式
        goods_type: '',// 商品类型（proprietary:自营，agent：代理）
        goods_id: '',//商品规格id,
        quantity: 10, //数量
    }]"
 */
export const getConfirmOrderDetail = params => {
    return ajax.post('getOrderConfirm', params)
}

export const postCreatOrder = params => {
    return ajax.post('orderCreate', params)
}
export const postBindDistributorCode = params => {
    return ajax.get('bindDistributor', params)
}
export const postZeroPay = params => {
    return ajax.post('zeroPay', params)
}
